const messages = {
  required: (field) => `This field is required`
}

const locale = {
  name: 'en',
  messages,
  attributes: {}
}

export default locale
